<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      @size-change="handleSizeChange"
      @on-selection-change="selectionChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
        <el-button
          style="margin-right: 10px"
          type="primary"
          @click="showMakeHeZhuDirectForm"
        >
          创建电商核注单
        </el-button>
      </div>
    </customize-page>
    <el-dialog
      width="400px"
      title="导入核注表体"
      :visible="showImportBodyVisible"
      @close="showImportBodyVisible = false"
    >
      <el-form :inline="true" :model="importBodyForm">
        <el-form-item label="运单号">
          <el-input
            type="textarea"
            autosize
            v-model="importBodyForm.mailNoList"
            placeholder="请输入运单号,多个单号以回车换行"
          />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showImportBodyVisible = false">取消</el-button>
        <el-button type="primary" @click="doImportBody">确定</el-button>
      </span>
    </el-dialog>
    <custom-he-zhu-body-dialog
      :visible="showImportCustomBodyVisible"
      @close="showImportCustomBodyVisible = false"
      @confirmImport="handleImportCustomBody"
    />
    <el-dialog title="手工放行" width="550px" :visible.sync="showFormDialog">
      <el-form
        style="width: 400px; margin: 0 auto"
        ref="form"
        :model="formData"
        label-width="80px"
      >
        <el-form-item label="核注单编号">
          <el-input v-model="formData.businessId"></el-input>
        </el-form-item>
        <el-form-item label="单一窗口编号">
          <el-input v-model="formData.singleWindowNo"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveManualDeclare">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="创建核注单表头"
      width="400px"
      :visible.sync="showMakeHeZhuDirectFormFlag"
    >
      <el-form
        ref="heZhuForm"
        :model="heZhuForm"
        label-width="110px"
        :rules="rules"
        label-position="right"
      >
        <el-form-item label="来源单号" prop="originOrderNo">
          <el-input v-model="heZhuForm.originOrderNo"></el-input>
        </el-form-item>
        <el-form-item label="账册号" prop="emsNo">
          <el-input v-model="heZhuForm.emsNo"></el-input>
        </el-form-item>
        <el-form-item label="经营企业" prop="bizOpCompanyCode">
          <el-select filterable v-model="heZhuForm.bizOpCompanyCode">
            <el-option
              v-for="item in getEECommerce"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收货企业" prop="rcvCompanyCode">
          <el-select filterable v-model="heZhuForm.rcvCompanyCode">
            <el-option
              v-for="item in getEECommerce"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申报企业" prop="dclCompanyCode">
          <el-select filterable v-model="heZhuForm.dclCompanyCode">
            <el-option
              v-for="item in getEECommerce"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="createHeZhuOrder">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";
import heZhuApi from "@/api/heZhuApi";
import { mapGetters } from "vuex";
import CustomHeZhuBodyDialog from "./components/CustomHeZhuBodyDialog";

export default {
  components: {
    CustomizePage,
    CustomHeZhuBodyDialog,
  },
  mixins: [Page],
  mounted() {
    this.fetch();
  },
  watch: {
    $route: {
      handler() {
        this.fetch();
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      getEECommerce: "getEECommerce",
      getTradeMode: "getTradeMode",
      getTransMode: "getTransMode",
      getCustomerList: "getCustomerList",
    }),
  },
  data() {
    return {
      uploadData: {
        _aid: 401,
      },
      showImportCustomBodyVisible: false,
      showImportBodyVisible: false,
      showFormDialog: false,
      showMakeHeZhuDirectFormFlag: false,
      manualDeclareHeZhuId: null,
      importBodyHeZhuId: null,
      formData: {},
      importBodyForm: {},
      loading: false,
      dataList: [],
      heZhuForm: {},
      rules: {
        emsNo: [{ required: true, message: "账册号不能为空", trigger: "blur" }],
        originOrderNo: [
          { required: true, message: "来源单号不能为空", trigger: "blur" },
        ],
        bizOpCompanyCode: [
          { required: true, message: "请选择经营企业", trigger: "change" },
        ],
        rcvCompanyCode: [
          { required: true, message: "请选择收货企业", trigger: "change" },
        ],
        dclCompanyCode: [
          { required: true, message: "请选择申报企业", trigger: "change" },
        ],
      },
      columns: [
        {
          title: "来源单号",
          key: "originOrderNo",
          width: 200,
          align: "center",
          render: (h, params) => {
            let id = params.row.id;
            return (
              <div>
                <a style="color:blue" onClick={this.showDetail.bind(this, id)}>
                  {params.row.originOrderNo}
                </a>
              </div>
            );
          },
        },
        {
          title: "核注清单编号",
          key: "copListNo",
          width: 200,
          align: "center",
        },
        {
          title: "海关清单编号",
          key: "businessId",
          width: 150,
          align: "center",
        },
        {
          title: "单一窗口号",
          key: "singleWindowNo",
          width: 200,
          align: "center",
        },
        {
          title: "账册号",
          key: "emsNo",
          width: 150,
          align: "center",
        },
        {
          title: "经营企业",
          key: "bizOpCompany",
          width: 200,
          align: "center",
          render: (h, param) => {
            let row = param.row;
            return (
              <div>
                <el-tag size="mini">{row.bizOpCompanyName}</el-tag>
                <el-tag size="mini">{row.bizOpCompanyNo}</el-tag>
              </div>
            );
          },
        },
        {
          title: "收货企业",
          key: "rcvCompany",
          width: 200,
          align: "center",
          render: (h, param) => {
            let row = param.row;
            return (
              <div>
                <el-tag size="mini">{row.rcvCompanyName}</el-tag>
                <el-tag size="mini">{row.rcvCompanyNo}</el-tag>
              </div>
            );
          },
        },
        {
          title: "申报企业",
          key: "dclCompany",
          width: 200,
          align: "center",
          render: (h, param) => {
            let row = param.row;
            return (
              <div>
                <el-tag size="mini">{row.dclCompanyName}</el-tag>
                <el-tag size="mini">{row.dclCompanyNo}</el-tag>
              </div>
            );
          },
        },
        {
          title: "申报状态",
          width: 200,
          key: "status",
          align: "center",
          render: (h, param) => {
            let row = param.row;
            const tagType = {
              INIT: ["info", "待申报"],
              DECLARED: ["warning", "已申报"],
              DECLARE_SUCCESS: ["success", "申报成功"],
              DECLARE_FAIL: ["error", "申报失败"],
            };
            return (
              <div>
                <el-tag type={tagType[row.status][0]}>
                  {tagType[row.status][1]}
                </el-tag>
              </div>
            );
          },
        },
        {
          title: "状态描述",
          width: 200,
          key: "statusDesc",
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          width: 250,
          fixed: "right",
          render: (h, param) => {
            let row = param.row;
            return (
              <div>
                {row.status !== "DECLARE_SUCCESS" && (
                  <a
                    style={{ color: "#409EFF", padding: "0 5px" }}
                    onClick={this.declare.bind(this, row)}
                  >
                    申报
                  </a>
                )}
                {row.status === "INIT" && (
                  <span>
                    <a
                      style={{ color: "#409EFF", padding: "0 5px" }}
                      onClick={this.importBody.bind(this, row)}
                    >
                      导入表体
                    </a>
                    {/* <a
                      style={{ color: "#409EFF", padding: "0 5px" }}
                      onClick={this.importCustomBody.bind(this, row)}
                    >
                      导入自定义表体
                    </a> */}
                  </span>
                )}
                {row.status !== "DECLARE_SUCCESS" && (
                  <a
                    style={{ color: "#409EFF", padding: "0 5px" }}
                    onClick={this.manualDeclareSuccess.bind(this, row)}
                  >
                    手工放行
                  </a>
                )}
                <a
                  style={{ color: "#409EFF", padding: "0 5px" }}
                  onClick={this.delete.bind(this, row)}
                >
                  删除
                </a>
              </div>
            );
          },
        },
      ],
      filterObj: {
        outBizId: "",
        bizId: "",
      },
      currentRow: [],
    };
  },
  methods: {
    showDetail(id) {
      this.$router.push({
        name: "eCommerceHeZhuDetail",
        params: { id },
      });
    },
    importBody(row) {
      this.importBodyHeZhuId = row.id;
      this.showImportBodyVisible = true;
    },
    importCustomBody(row) {
      this.importBodyHeZhuId = row.id;
      this.showImportCustomBodyVisible = true;
    },
    async doImportBody() {
      const mailNoList = this.importBodyForm.mailNoList;
      const list = mailNoList.split("\n");
      const res = await heZhuApi.createECommerceBody({
        request: {
          heZhuOrderId: this.importBodyHeZhuId,
          mailNoList: list.map((l) => l.trim()),
        },
      });
      if (res.value) {
        this.$message.success("导入成功");
        this.importBodyHeZhuId = null;
        this.showImportBodyVisible = false;
        this.importBodyForm.merchantOrderNoList = "";
      }
    },
    async handleImportCustomBody(data) {
      const res = await heZhuApi.createCustomECommerceBody({
        request: {
          heZhuOrderId: this.importBodyHeZhuId,
          ...data,
        },
      });
      if (res.value) {
        this.$message.success("导入成功");
        this.showImportCustomBodyVisible = false;
        this.importBodyHeZhuId = null;
        this.fetch();
      }
    },
    showMakeHeZhuDirectForm() {
      this.showMakeHeZhuDirectFormFlag = true;
    },
    createHeZhuOrder() {
      this.$refs["heZhuForm"].validate((valid) => {
        if (valid) {
          this.loading = true;
          heZhuApi
            .createECommerceHead({
              request: this.heZhuForm,
            })
            .then((res) => {
              if (res.value) {
                this.$message.success("生成核注清单成功");
                this.showMakeHeZhuDirectFormFlag = false;
                this.fetch();
              }
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    manualDeclareSuccess(row) {
      this.manualDeclareHeZhuId = row.id;
      this.formData = {};
      this.showFormDialog = true;
    },
    saveManualDeclare() {
      this.$confirm("此操作将手工放行核注单, 请确认数据正确", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        heZhuApi
          .manualDeclareSuccess({
            request: {
              id: this.manualDeclareHeZhuId,
              singleWindowNo: this.formData.singleWindowNo,
              businessId: this.formData.businessId,
            },
          })
          .then((res) => {
            if (res.value) {
              this.$message({
                type: "success",
                message: "申报成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: res.resultMessage,
              });
            }
            this.fetch();
          });
      });
    },
    declare(row) {
      this.$confirm("此操作将申报核注单, 请确认数据正确", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        heZhuApi
          .declare({
            heZhuOrderId: row.id,
          })
          .then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: "申报成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: res.resultMessage,
              });
            }
            this.fetch();
          });
      });
    },
    delete(row) {
      this.$confirm("此操作将删除核注单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        heZhuApi
          .delete({
            heZhuOrderId: row.id,
          })
          .then((res) => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.fetch();
          });
      });
    },
    fetch() {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      let searchCondition = {
        ...filterParams,
        currentPage: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };
      heZhuApi.eCommercePageQuery({ request: searchCondition }).then((res) => {
        this.dataList = res.items;
        this.pagination.currentPage = res.pageInfo.currentPage;
        this.pagination.pageSize = res.pageInfo.pageSize;
        this.pagination.totalCount = res.pageInfo.totalCount;
        this.loading = false;
      });
    },
    selectionChange(rows) {
      this.currentRow = rows;
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "来源单号",
              model: "originOrderNo",
              type: type.INPUT,
            },
            {
              label: "单一窗口单号",
              model: "singleWindowNo",
              type: type.INPUT,
            },
            {
              label: "海关清单单号",
              model: "businessId",
              type: type.INPUT,
            },
            {
              label: "核注单企业单号",
              model: "copListNo",
              type: type.INPUT,
            },
            {
              label: "状态",
              model: "status",
              type: type.SELECT,
              props: {
                data: [
                  { value: "INIT", label: "初始化" },
                  { value: "DECLARED", label: "已申报" },
                  { value: "DECLARE_SUCCESS", label: "申报成功" },
                  { value: "DECLARE_FAIL", label: "申报异常" },
                ],
              },
            },
          ],
        },
      ];
    },
  },
};
</script>

<style>
.avatar-uploader {
  display: inline-block;
}

.inline-p {
  display: inline-block;
}

.inline-p span {
  color: #3399ff;
}

.filter_con.filterUp .filter-form {
  height: auto;
  overflow: visible;
}
</style>
